module.exports = __webpack_public_path__ + "static/media/el-ateneo.016c734b.md";